// service/contact/hooks/useContactOwners.ts

import { useQuery } from "@tanstack/react-query";
import { contactApi, contactQueryKeys } from "service/crm/api/contact";

export const useContactOwners = (orgUuid?: string, search?: string) => {
  return useQuery({
    queryKey: contactQueryKeys.owners(orgUuid, search),
    queryFn: () => contactApi.getContactOwners(orgUuid, search),
    enabled: !!orgUuid,
  });
};